import { render, staticRenderFns } from "./NewCommandePopup.vue?vue&type=template&id=472891c4"
import script from "./NewCommandePopup.vue?vue&type=script&lang=js"
export * from "./NewCommandePopup.vue?vue&type=script&lang=js"
import style0 from "./NewCommandePopup.vue?vue&type=style&index=0&id=472891c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports